import React, { useMemo, useState } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

import { getPhaseRSC, getLongEventRSC, getUnit, getLevelRSC } from 'helpers/rsc'
import NotAvailable from 'components/common/NotAvailable'
import Label from "components/general/Label";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const GlfCoursestats = ({ results }) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const _event = getLongEventRSC(mirs_rsc);
    const _phase = getPhaseRSC(mirs_rsc);

    const _eventAndUnits = [
        _event
        , _phase + '000100--'
        , _phase + '000200--'
        , _phase + '000300--'
        , _phase + '000400--'
    ];

    return (
        <Tabs id="mirs-nav-course-stats"
            //defaultActiveKey={`1-${mirs_rsc}`} 
            className="mb-3 mirs-tab-result1"
        >
            {_eventAndUnits.map((unit, index) => {
                let result = results.find(result => result.data?.stats?.find(x => x !== undefined)?.rsc === unit)
                let components
                let label = 'LabelRound' + getUnit(unit).replaceAll('-', '').replaceAll('0', '')
                let title = getLevelRSC(unit) === 'EVENT'
                    ? <Label data="LabelCumulative" sport={mirs_discipline} />
                    : <Label data={label} sport={mirs_discipline} />
                if (result) {
                    //let stats = result?.data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
                    components = <>
                        <GlfCoursestatsTableUp data={result?.data} />
                        <GlfCoursestatsTableDown data={result?.data} results={results} index={index} units={_eventAndUnits} />
                    </>
                } else {
                    components = <NotAvailable />
                }
                return (
                    <Tab key={`mirs-tab-course-stats-${index}-${unit}`} eventKey={`${index}-${unit}`} title={title} disabled={false} >
                        {components}
                    </Tab>
                )

            })
            }
        </Tabs>
    )

};

export default GlfCoursestats;



const ToggleGroup = ({ setMetres }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const types = [{ type: 'Metres', label: <Label data="HeaderMetres" sport={mirs_discipline} /> }, { type: 'Yardas', label: <Label data="HeaderImperial" sport={mirs_discipline} /> }];

    const [active, setActive] = useState(types[0].type);
    const handleClick = (e) => {
        setActive(e.target.value)
        setMetres(e.target.value === 'Metres' ? false : true)
    }
    return (
        <ButtonGroup onClick={handleClick}>
            {types.map((obj, index) => (
                <Button key={`btn-selector-${index}`} className='selector' variant="none" active={active === obj.type} value={obj.type}>{obj.label}</Button>
            ))}
        </ButtonGroup>
    );
}

const GlfCoursestatsTableUp = ({ data }) => {
    const { breakPoint } = useViewport();
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const [hideMetres, setHideMetres] = useState(false)
    let hideCol = hideMetres ? 'Metres' : 'Imperial'
    let hiddenColumns = [hideCol]
    // let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns
    let columns = useMemo(() =>
        createColumns([
            'hole',
            'par',
            { id: 'metres', fixed: false, "config": { Header: 'HeaderMetresImperial' } },
            { id: 'imperial', fixed: false, "config": { Header: 'HeaderMetresImperial' } },
            { id: 'difficulty', fixed: false },
            { id: 'average', fixed: false },
            { id: 'avg_to_par', fixed: false },
            { id: 'albatros', fixed: false },
            { id: 'eagle', fixed: false },
            { id: 'birdie', fixed: false },
            { id: 'pars', fixed: false },
            { id: 'bogey', fixed: false },
            { id: 'dbl_bogey', fixed: false },
            { id: 'other', fixed: false },
            { id: 'minimum', fixed: false },
            { id: 'maximum', fixed: false }
        ], mirs_discipline, true)
        , [breakPoint]);
    let rows = getRoundData(data)

    return (
        <div>

            <MirsTable
                //  id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
                //caption={<Navbar setMetres={setMetres} />}
                data={rows}
                columns={columns}
                //keyRow={"athlete-code"}
                // initialSortBy={[{ id: 'Hole', desc: false }]}
                colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '8,6' : '7,7'}
                showNavExtendedData={true}
                colIndex={1}
                hiddenColumns={hiddenColumns}
                extendedComponents={<ToggleGroup setMetres={setHideMetres} />}
            />

        </div>

    )
}



const GlfCoursestatsTableDown = ({ data, results, index, units }) => {
    const { breakPoint } = useViewport();
    const { mirs_discipline } = useUrlFriendlyToParameters();
    const _eventAndUnits = units;
    let colsData0
    let colsData = []
    {
        _eventAndUnits.map((unit, index) => {

            let label = 'LabelRound' + getUnit(unit).replaceAll('-', '').replaceAll('0', '')


            let title = <Label data='LableRound1' sport={mirs_discipline} />
            return (
                (getLevelRSC(unit) === 'EVENT')
                    ?
                    colsData0 =
                    {
                        "id": "data0",
                        "config": {
                            Header: "LabelCumulative",
                            headerClassName: "w-10 text-center",
                            className: "text-center",
                        }
                    }


                    : colsData.push(
                        {
                            "id": "data" + index,
                            "config": {
                                Header: label,
                                headerClassName: "w-10 text-center",
                                className: "text-center",
                            }
                        }
                    )

            );

        })


        if (colsData0) { colsData.push(colsData0) }
        let rows = getRoundData2(results, data, mirs_discipline)
        let columns = useMemo(() =>
            createColumns([{
                "id": "stat",
                "config": {
                    headerClassName: "text-start",
                    className: "text-start",
                    Header: 'mirs-none'
                }
            },
            ...colsData
            ]
                , mirs_discipline)
            , [breakPoint, rows]);


        let hiddenColumns = []


        switch (String(index)) {
            case '1':
                hiddenColumns = ['Data0', 'Data2', 'Data3', 'Data4']
                break;
            case '2':
                hiddenColumns = ['Data0', 'Data1', 'Data3', 'Data4']
                break;
            case '3':
                hiddenColumns = ['Data0', 'Data1', 'Data2', 'Data4']
                break;
            case '4':
                hiddenColumns = ['Data0', 'Data1', 'Data2', 'Data3']
                break;
            default:
        }


        return (
            <MirsTable
                data={rows}
                columns={columns}
                hiddenColumns={hiddenColumns}
            />
        )
    }
}


function getRoundData(data) {
    let stats = data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
    let config = data?.config
    let rowData;
    /*
    let holes = config?.extendedConfig
        .filter(extConfig => extConfig.type === 'EC' && extConfig.code === 'HOLE')
        .sort((a, b) => a.pos - b.pos)
*/
    let linesArray = []
    for (let i = 1; i <= 18; i++) {
        //rowData = getRoundDataRow(data, 'HOLE', hole.pos)
        rowData = getRoundDataRow(data, 'HOLE', i)
        linesArray.push(rowData)
        //if (Number(hole.pos) === 9) {
        if (Number(i) === 9) {
            rowData = getRoundDataRow(data, 'COURSE', 1, 'OUT')
            linesArray.push(rowData)

        }
        //if (Number(hole.pos) === 18) {
        if (Number(i) === 18) {
            rowData = getRoundDataRow(data, 'COURSE', 2, 'IN')
            linesArray.push(rowData)
            rowData = getRoundDataRow(data, 'COURSE', 3, 'Total')
            linesArray.push(rowData)
        }
        //})
    }
    //}

    return (
        linesArray.reverse() //revrse array order
    )

}

function getRoundDataRow(data, type, pos, label) {
    let stats = data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
    let config = data?.config

    let configStats = config?.extendedConfig?.find(extConfig => extConfig.type === 'EC' && extConfig.code === type && extConfig.pos == String(pos))
    let statsSource = stats?.statsItems?.find(statItem => statItem.type === 'ST' && statItem.code === type && statItem.pos == String(pos))

    //From CONFIG
    let metres = configStats?.extension?.find(ext => ext.code === 'DISTANCE' && ext.pos === '0').value
    let imperial = configStats?.extension?.find(ext => ext.code === 'DISTANCE' && ext.pos === '1').value
    let par = configStats?.value
    //from DT_STATS
    let difficulty = statsSource?.extendedStats?.find(stat => stat.code === 'DIFFICULTY')?.value
    let average = statsSource?.value
    let avg_to_par = statsSource?.extendedStats?.find(stat => stat.code === 'AVG_TO_PAR')?.value
    let albatros = statsSource?.extendedStats?.find(stat => stat.code === 'ALBATROSS')?.value
    let eagle = statsSource?.extendedStats?.find(stat => stat.code === 'EAGLE')?.value
    let birdie = statsSource?.extendedStats?.find(stat => stat.code === 'BIRDIE')?.value
    let pars = statsSource?.extendedStats?.find(stat => stat.code === 'PAR')?.value
    let bogey = statsSource?.extendedStats?.find(stat => stat.code === 'BOGEY')?.value
    let dbl_bogey = statsSource?.extendedStats?.find(stat => stat.code === 'DBL_BOGEY')?.value
    let minimum = statsSource?.extendedStats?.find(stat => stat.code === 'MINIMUM')?.value
    let maximum = statsSource?.extendedStats?.find(stat => stat.code === 'MAXIMUM')?.value
    let other = statsSource?.extendedStats?.find(stat => stat.code === 'OTHER')?.value


    return {
        hole: label ? label : pos,
        par: par,
        metres: metres,
        imperial: imperial,
        difficulty: difficulty,
        average: average,
        avg_to_par: avg_to_par,
        albatros: albatros,
        eagle: eagle,
        birdie: birdie,
        pars: pars,
        bogey: bogey,
        dbl_bogey: dbl_bogey,
        minimum: minimum,
        maximum: maximum,
        other: other
    }

}

function getRoundData2(results, data, discipline) {
    //Data es un array de units + acumulado 

    let linesArray = []
    let data1 = {}
    let rowData;
    let rowTable = []
    let stastNames = ['EQ_PAR', 'GT_79', 'GT_PAR', 'LT_70', 'LT_PAR', 'EQ_LT_PAR']
    results?.map((result) => {
        let stats = result?.data?.stats?.find(x => x !== undefined) //es un array nos posicionamos en el primero ,  query solo devuelve 1 elemento
        let statsSource = stats?.statsItems?.find(statItem => statItem.type === 'ST' && statItem.code === 'ROUND')
        let rowStats = []
        stastNames.forEach((name) => {
            rowStats.push(statsSource?.extendedStats?.find(stat => stat.code === name)?.value)
        })
        rowTable.push(rowStats)
    })

    stastNames?.map((name, index) => {
        rowData = {
            stat: <Label data={name} sport={discipline} />,
            data0: rowTable[0][index],
            data1: rowTable[1][index],
            data2: rowTable[2][index],
            data3: rowTable[3][index],
            data4: rowTable[4][index],
        }
        linesArray.push(rowData)
    })


    return (
        linesArray.reverse() //revrse array order
    )



}

export function createColumns(config, discipline, extendedProps = false) {
    let columnsExt = []
    let index = 1
    let props = {}
    Array.isArray(config) &&
        config.forEach((item) => {
            let itemObj

            if (typeof item === 'object' || extendedProps) {

                if (typeof item !== 'object') {
                    itemObj = {
                        "id": item
                    }
                } else {
                    itemObj = item;
                }

                itemObj['fixed'] = itemObj.fixed !== undefined ? itemObj.fixed : true;
                itemObj['isVisible'] = itemObj.isVisible !== undefined ? itemObj.isVisible : false;

                if (extendedProps && !itemObj.fixed) {
                    props['isVisible'] = false;
                    props['columnIndex'] = index;
                    index++;
                }

                let headerLabel = ''
                if (itemObj?.config?.Header) {
                    if (itemObj?.config?.Header !== 'mirs-none') {
                        headerLabel = <Label data={itemObj?.config?.Header} sport={discipline} />
                    }
                } else {
                    headerLabel = <Label data={labeledHeader(capitalize(itemObj.id))} sport={discipline} />
                }


                columnsExt.push(
                    {
                        id: capitalize(itemObj.id),
                        Header: headerLabel,
                        headerClassName: itemObj?.config?.headerClassName ? itemObj?.config?.headerClassName : "w-5 text-end mirs-break-line",
                        accessor: itemObj.id,
                        disableSortBy: itemObj?.disableSortBy ? itemObj?.disableSortBy : true,
                        className: itemObj?.config?.className ? itemObj?.config?.className : "text-end",
                        ...props
                    },
                )
            } else {
                columnsExt.push(
                    {
                        id: capitalize(item),
                        Header: <Label data={labeledHeader(capitalize(item))} />,
                        headerClassName: "w-5 text-end",
                        accessor: item,
                        disableSortBy: true,
                        className: "text-end"
                    },
                )
            }
        })

    return columnsExt

}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function labeledHeader(str) {
    return "Header" + str;
}

const CaptionTable = ({ caption }) => {
    return (
        <span>
            {caption}
        </span>
    );
}

